The identifier for the `CandidateProfile`.

This profile can be queried at any time by passing this identifier string to `candidateProfile`.
